import { type License } from "@clipboard-health/contract-worker-app-bff";

export const isActiveLicense = (license: License) => {
  return license.attributes.status === "ACTIVE" || license.attributes.status === "EXPIRING";
};
